export default {
  filterOoo: 'Filter...',
  equals: 'Equals',
  inRange: 'In range',
  inRangeStart: 'from',
  inRangeEnd: 'to',
  lessThan: 'Less than',
  lessThanOrEqual: 'Less than or equal',
  greaterThan: 'Greater than',
  greaterThanOrEqual: 'Greater than or equal',
  contains: 'Contains',
  andCondition: 'AND',
  orCondition: 'OR',
  noRowsToShow: 'No rows to show',
};
